import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useRouteMatch, Link } from 'react-router-dom';

import { DeprecatedPlusIcon } from '@mssgme/icons';
import { IconButton } from '@mssgme/ui';

import QuickRepliesDialog from './QuickRepliesDialog';
import QuickReplyItem, { replyType } from './QuickReplyItem';
import useQuickReplyList from './useQuickReplyList';

import styles from './QuickReplyList.scss';

PureQuickReplyList.propTypes = {
    items: PropTypes.arrayOf(replyType).isRequired,
    onSelectItem: PropTypes.func,
    onClose: PropTypes.func,
};

export function PureQuickReplyList({ items, onSelectItem, onClose, ...rest }) {
    const { t } = useTranslation('inbox');
    const { url } = useRouteMatch();

    const handleSelect = (...args) => {
        onSelectItem && onSelectItem(...args);
        onClose && onClose();
    };

    return (
        <QuickRepliesDialog
            title={t('QuickRepliesPopup.title')}
            buttons={
                <IconButton as={Link} to={`${url}/new`}>
                    <DeprecatedPlusIcon size={18} title={t('QuickRepliesPopup.addTip')} />
                </IconButton>
            }
            footer={t('QuickRepliesPopup.footerText')}
            onClose={onClose}
            {...rest}
        >
            {items.length > 0 && (
                <ul className={styles.list}>
                    {items.map((item) => (
                        <QuickReplyItem data={item} key={item._id} isEdit onSelect={handleSelect} />
                    ))}
                </ul>
            )}
        </QuickRepliesDialog>
    );
}

export default function QuickReplyList(props) {
    const state = useQuickReplyList();

    return <PureQuickReplyList {...state} {...props} />;
}
